import { defineMessages } from "react-intl";

export default defineMessages({
  infoCard: {
    id: "creditCardForm.infoCard",
    defaultMessage: "Card informations",
  },
  cardOwner: {
    id: "creditCardForm.cardOwner",
    defaultMessage: "Card owner",
  },
  firstNameLastName: {
    id: "creditCardForm.firstNameLastName",
    defaultMessage: "First name Last name",
  },
  incompleteName: {
    id: "creditCardForm.incompleteName",
    defaultMessage: "The name is not complete",
  },
});
